export default __webpack_public_path__ + "static/media/arrow_forward_black-1.0546e56a.png";